import { ApiError } from '../buildApiErrorPipeline';

// https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#queryfn-function-return-value
// The error must be available on the property "error" to fully map by RTK
export const mapErrorToApiSlice = (error: ApiError) => ({
  error,
});
